<template>
    <div class="full-chat-w single-page-container">
        <div class="content-box col-sm-8 col-xs-12">
            <div class="element-wrapper">
                <h6 class="element-header">
                    Import Products
                </h6>
                <div class="element-box p-10">
                    <ImportProductsForm :session="id_session" />
                </div>
            </div>
        </div>
        <div class="content-panel col-sm-4 col-xs-hidden middle ">
            <div class="content-panel-close">
                <i class="os-icon os-icon-close"></i>
            </div>
            <div class="element-wrapper">
                <h6 class="element-header">Guide</h6>
                <div class="element-box-tp">
                    <div class="todo-list">
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Look for session folder in the Bucket</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Upload all images with an RMS identifiable name</div>
                            </div>
                        </a>
                        <a class="todo-item">
                            <div class="ti-info">
                                <div class="ti-header">Start the consumer</div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImportProductsForm from '@/components/common/Forms/ImportProducts'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  props: ['id_session'],
  mixins: [CommonFunctions],
  components: { ImportProductsForm },
  data () {
    return {
      sideBarContent: 'users',
      channels: '',
      categories: '',
      users: '',
      userSearch: '',
      filteredUsers: '',
      selectedUsers: []
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/photodesk/session/add/helper'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.channels = response.data.channels
          self.categories = response.data.categories
          self.users = self.filteredUsers = response.data.users
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
        })
    },
    addUser (header) {
      var session_type = $('select[name="shoot_type"] option:selected').val()
      if (session_type) {
        if (session_type != 'model' && header.role_code == 'model') {
          alert('Models cannot be added to non model sessions')
          return
        }
      } else {
        alert('Select a session type first')
        return
      }
      // check if model is already added
      for (var i = 0; i < this.selectedUsers.length; i++) {
        if (this.selectedUsers[i].role_code === 'model') {
          alert('Only one model is allowed')
          return
        }
      }

      this.selectedUsers.push(header)
      this.$store.dispatch('updateToast', {
        text: 'User added to session',
        show: true
      })
      this.updateUser()
    },
    removeUser (data) {
      console.log('remove')
      for (var i = 0; i < this.selectedUsers.length; i++) {
        if (this.selectedUsers[i].id_user === data.id_user) {
          this.selectedUsers.splice(i, 1)
          break
        }
      }
      this.$store.dispatch('updateToast', {
        text: 'User removed from session',
        show: true
      })
      this.updateUser()
    },
    updateUser () {
      this.filteredUsers = this.users.filter(
        user =>
          !this.selectedUsers.includes(user) &&
          user.name.indexOf(this.userSearch) > -1
      )
    },
    onStepChange (data) {
      this.sideBarContent = data
    }
  },
  computed: {
    roles () {
      var self = this
      const roles = this.users.map(user => {
        return self.capitalize(user.role_code)
      })

      return [...new Set(roles)]
    }
  },
  watch: {
    userSearch () {
      this.updateUser()
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
</style>
